import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
    selector: 'app-section-flyout',
    templateUrl: './section-flyout.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, TranslocoModule, MatCardModule]
})
export class SectionFlyoutComponent {
    @Input() flyoutKey?: string;
    @Input() active = false;
    @Input() flipUp = false;
}
